import { useCallback } from 'react';
import { useQuery, useQueryClient } from 'react-query';
import { IsSortCountryNumber } from 'common';
export default function useFilterAddress() {
  const queryClient = useQueryClient();
  const { data: fillterAddress }: any = useQuery('filter_address', () => queryClient.getQueryData('filter_address'));

  const setFilterAddress = useCallback((value: any) => queryClient.setQueryData('filter_address', value), [
    queryClient,
  ]);
  return { fillterAddress: fillterAddress || { keyword: '', isSort: IsSortCountryNumber.DESC }, setFilterAddress };
}
